import React from 'react';

import {
  TextInput,
  Create,
  SimpleForm,
  Show,
  SimpleShowLayout,
  List,
  Edit,
  Datagrid,
  TextField,
  EditButton,
  translate as t,
} from 'admin-on-rest';

export const GenreList = t((props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="name.sv" label="SV" />
      <TextField source="name.en" label="EN" />
      <EditButton />
    </Datagrid>
  </List>
));

const GenreTitle = t(({ record, locale }) => (
  <span>{record ? `${record.name[locale]}` : ''}</span>
));

export const GenreShow = t((props) => (
  <Show title={<GenreTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="name.sv" />
      <TextField source="name.en" />
    </SimpleShowLayout>
  </Show>
));

export const GenreCreate = t((props) => (
  <Create title={props.translate('create.item', { item: props.translate('academy.genre') })} {...props}>
    <SimpleForm>
      <TextInput label={`${props.translate('title')} ${props.translate('swedish')}`} source="name.sv" />
      <TextInput label={`${props.translate('title')} ${props.translate('english')}`} source="name.en" />
    </SimpleForm>
  </Create>
));

export const GenreEdit = t((props) => (
  <Edit title={<GenreTitle />} {...props}>
    <SimpleForm>
      <TextInput label={`${props.translate('title')} ${props.translate('swedish')}`} source="name.sv" />
      <TextInput label={`${props.translate('title')} ${props.translate('english')}`} source="name.en" />
    </SimpleForm>
  </Edit>
));
